<template>
  <div class="content-bg" style="margin-top: 20px">
    <div class="content" style="background: white">
      <div class="row">
        <div class="col-xs-3">
          <div class="left-nav">
            <ul>
              <li class="title">
                <a href="#">{{ columnPidName }}</a>
              </li>
            </ul>
            <ul>
              <li v-for="(item, index) in childrenLsit" :key="index">
                <a
                  :class="num == item.id ? 'newsytle' : ''"
                  href="javascript:;"
                  @click="
                    getColumnDataInfo(item.id, item.templateType, item.label)
                  "
                >{{ item.label }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-xs-9">
          <div class="index-middle" style="border: none">
            <div class="module-head" style="background: white">
              <span
                class="title"
                style="
                  color: #0d4c99;
                  font-size: 18px;
                  width: 135px;
                  text-align: left;
                  margin-left: -490px;
                "
              >{{ columnName }}</span>
              <div class="he">
                <span style="color: #999999">>></span>
                <span>
                  <a class="hh" href="javascript:;" tppabs="http://www.gxlyzjz.cn/">首页</a>
                </span>
                <span style="color: #999999">>></span>
                <span>
                  <a class="hh">{{ columnPidName }}</a>
                </span>
                <span style="color: #999999">>>></span>
                <span>
                  <a class="hh">{{ columnName }}</a>
                </span>
              </div>
            </div>

            <div>
              <!-- 详细信息 -->
              <div class="table_outer bgFFF mt15" style="width: 868px">
                <!-- 未登录 -->
                <div v-if="num == 0">
                  <div class="table_search">
                    <!--<span>互动交流</span>-->
                  </div>

                  <div style="height: 20px; padding: 5px 5px 5px 5px"></div>
                  <div class="pd20">
                    <table class="table01" width="848px">
                      <div
                        style="
                          text-align: center;
                          display: table-cell;
                          vertical-align: middle;
                        "
                      >
                        游客您好，互动交流查看需要先登录，您还没有登录哦！
                        <router-link
                          to="/register"
                          class="return"
                          style="text-decoration: underline; color: blue"
                        >免费注册</router-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <router-link
                          to="/login"
                          style="text-decoration: underline; color: blue"
                        >会员登录</router-link>
                      </div>
                    </table>
                  </div>
                </div>
                <!-- 已登录 -->
                <div v-if="num == 3">
                  <div class="table_search">
                    <!--<span>互动交流</span>-->
                    <a class="border-btn fr mt5" @click="toAdd()">新增</a>
                  </div>

                  <div style="height: 20px; padding: 5px 5px 5px 5px"></div>
                  <div class="pd20">
                    <table class="table01" width="848px">
                      <div
                        style="
                          width: 828px;
                          text-align: center;
                          display: table-cell;
                          vertical-align: middle;
                        "
                      >
                        <thead height="40px" table-layout="auto" style="background: #f2f2f2">
                          <tr width="806px">
                            <th width="290px" style="text-align: center">标题</th>
                            <th width="290px" style="text-align: center">发布时间</th>
                            <th width="290px" style="text-align: center">状态</th>
                          </tr>
                        </thead>
                        <tbody id="target">
                          <tr v-for="(item,index) in dataList" :key="index">
                            <td>
                              <a @click="toDetail(item.id)">
                                {{item.leaveTitle}}
                                <span style="display: none">63</span>
                              </a>
                            </td>
                            <td>{{item.gmtCreat}}</td>
                            <td>
                              <a class="btn common" @click="toDetail(item.id)">
                                <font color="#ff0000">{{showStatus(item.isReply)}}</font>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </div>
                    </table>
                    <div class="page_div clearfix mt10" id="fenye">
                      <el-pagination
                        v-show="totalCount>0"
                        :total="totalCount"
                        :page.sync="queryParams.pageNum"
                        :limit.sync="queryParams.pageSize"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                      ></el-pagination>
                    </div>
                  </div>
                </div>

                <!--追问详情信息 -->
                <div class="pd20" id="interactiveId" v-if="num == 2">
                  <div class="centTitle" style="font-size:25px;">{{wordList.leaveTitle}}</div>
                  <p class="Releasetime" style="text-align: right; vertical-align:botton">
                    发布时间：
                    <span class="times">{{wordList.gmtCreat}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  </p>
                  <el-divider></el-divider>
                  <div class="centBOX">
                    <div class="centProblem" style="text-align: left; vertical-align:botton">
                      <p class="proTitle">
                        问题具体内容：
                        <span>{{wordList.content}}</span>
                      </p>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  <div v-for="(item,index) in wordList.leaveWordList" :key="index">
                    <div class="centProblem" style="text-align: left; vertical-align:botton">
                      <p class="centReply">
                        会员[{{username}}]追问：
                        <span>{{item.content}}</span>
                      </p>
                      <p class="Replytimes">
                        回复时间：
                        <span class="times">{{item.gmtCreat}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      </p>
                    </div>
                    <el-divider></el-divider>
                  </div>
                  <div class="centProblem">
                    <p class="centReply">
                      回复内容：
                      <textarea
                        class="textarea01"
                        id="demo"
                        style="width: 570px; margin-top: 50px"
                        v-model="contentWord"
                      ></textarea>
                    </p>
                    <!--<p class="Replytimes">回复时间：-->
                    <!--<span class="times">2019/02/01&nbsp;&nbsp;&nbsp;&nbsp;12:30</span>-->
                    <!--</p>-->
                  </div>
                  <div class="tc" style="margin-top: 50px">
                    <button class="btn border-btn w110" type="button" @click="tosave">提交</button>

                    <a
                      class="btn border-btn w110 ml10"
                      @click="num=3"
                      style="background-color: #fff; color: #51b3fe !important"
                    >返回</a>
                  </div>
                </div>
                <!-- 添加新的留言 -->
                <div v-if="num == 1">
                  <el-form id="interactive" :rules="loginRules" ref="loginForm" :model="form">
                    <table class="company-info">
                      <tr>
                        <th width="250">
                          <em class="cR">*</em>姓名：
                        </th>
                        <td style="text-align: left;">
                          <el-form-item prop="userName" style="margin-bottom:0px">
                            <el-input
                              type="text"
                              name="fullName"
                              width="20"
                              maxlength="20"
                              v-model="form.userName"
                            />
                          </el-form-item>
                        </td>
                      </tr>
                      <tr>
                        <th width="250">
                          <em class="cR">*</em>联系方式：
                        </th>
                        <td>
                          <el-form-item prop="phone" style="margin-bottom:0px">
                            <el-input type="text" maxlength="30" name="contactWay" v-model="form.phone" />
                          </el-form-item>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <em class="cR">*</em>标题：
                        </th>
                        <td>
                          <el-form-item prop="leaveTitle" style="margin-bottom:0px">
                            <el-input type="text" maxlength="60"  name="title" v-model="form.leaveTitle" />
                          </el-form-item>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          <em class="cR">*</em>内容：
                        </th>
                        <td>
                          <!-- <textarea
                            type="text"
                            name="content"
                            class="textarea01"
                            v-model="form.content"
                          ></textarea>-->
                          <el-form-item prop="content" style="margin-bottom:0px">
                            <el-input
                              type="textarea"
                              placeholder="请输入内容"
                              v-model="form.content"
                              maxlength="400"
                              :rows="5"
                            ></el-input>
                          </el-form-item>
                        </td>
                      </tr>
                    </table>
                  </el-form>
                  <div class="tc" style="margin-top: 50px">
                    <!--<button class="btn border-btn w110" type="button">保存</button>-->
                    <button class="btn border-btn w110 ml10" type="button" @click="save()">提交</button>
                    <a
                      class="btn border-btn w110 ml10"
                      @click="num=3"
                      style="background-color: #fff; color: #51b3fe !important"
                    >返回</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDataInfo,
  getColumnList,
  getWordInfo,
  addWord,
  getWordData
} from "@/api/content/column";
export default {
  data() {
    return {
      selectIndex: 1,
      //定义模板
      templateStyle01Begin:
        "<ul class='news-list' style='width: 95%;margin: 0 auto;'>",
      templateStyle01End: "",
      templateTypeId: 6,
      id: 0,
      num: 0,
      columnName: "",
      columnPidName: "",
      dataList: null,
      columnList: null,
      content: null,
      childrenLsit: null,
      wordList: null,
      username: null,
      //总页数
      totalPage: 10,
      //总条数
      totalCount: 0,
      //分页查询
      queryParams: {
        pageNum: 1,
        userId: 0,
        pageSize: 10,
        status: 1,
        pid: 0
      },
      loginRules: {
        userName: [
          { required: true, trigger: "blur", message: "请输入您的账号" }
        ],
        phone: [
          { required: true, trigger: "blur", message: "请输入你的联系方式" }
        ],
        leaveTitle: [
          { required: true, trigger: "change", message: "请输入标题" }
        ],
        content: [{ required: true, trigger: "blur", message: "请输入内容" }]
      },
      contentWord: null,
      form: {
        id: null,
        pid: null,
        userName: null,
        phone: null,
        leaveTitle: null,
        status: 0,
        isReply: 2,
        gmtCreat: null,
        gmtUpdate: null,
        gmtDelete: null,
        content: null,
        type: 1,
        userId: null,
        token: null
      }
    };
  },
  created() {
    this.init();
  },
  watch: {
    //监听到路由（参数）改变
    $route(val, from) {
      // 拿到目标参数 val.query.id 去请求接口
      this.inits(val.query.id);
    }
  },
  methods: {
    tosave() {
      if (this.contentWord != null) {
        this.form.pid = this.wordList.id;
        this.form.token = localStorage.getItem("token");
        this.form.userId = localStorage.getItem("userId");
        this.form.userName = localStorage.getItem("userName");
        this.form.type = 2;
        this.form.status = 1;
        this.form.isReply = 2;
        this.form.content = this.contentWord;
        addWord(this.form).then(response => {
          this.$alert("<font color='red'> 回复成功</font>", "系统提示", {
            dangerouslyUseHTMLString: true,
            type: "success"
          })
            .then(() => {
              this.getList();
              this.num = 3;
            })
            .catch(() => {});
        });
      }
    },
    handleSizeChange(str) {
      this.queryParams.pageSize = str;
      this.getList();
    },
    handleCurrentChange(str) {
      this.queryParams.pageNum = str;
      this.getList();
    },
    getList() {
      this.queryParams.userId =
        localStorage.getItem("userId") == null
          ? "0"
          : localStorage.getItem("userId");

      if (localStorage.getItem("token")) {
        this.num = 3;
        getWordInfo(this.queryParams).then(response => {
          this.dataList = response.rows;
          this.totalCount = response.total;
          this.totalPage = Math.ceil(this.totalCount / 10);
        });
      }
    },
    save() {
      if (localStorage.getItem("token")) {
        this.form.token = localStorage.getItem("token");
        this.form.userId = localStorage.getItem("userId");
        this.form.pid = 0;
        this.form.type = 1;
        this.form.status = 1;
        this.form.isReply = 2;
        if(this.form.userName==null||this.form.userName=='') {
          this.$alert("<font color='red'> 请输入用户名</font>", "系统提示", {
              dangerouslyUseHTMLString: true,
              type: "success"
            })
        }else if(this.form.phone==null||this.form.phone==''){
          this.$alert("<font color='red'> 请输入联系方式</font>", "系统提示", {
              dangerouslyUseHTMLString: true,
              type: "success"
            })
        }else if(this.form.leaveTitle==null||this.form.leaveTitle==''){
          this.$alert("<font color='red'> 请输入标题</font>", "系统提示", {
              dangerouslyUseHTMLString: true,
              type: "success"
            })
        }else if(this.form.content==null||this.form.content==''){
          this.$alert("<font color='red'> 请输入内容</font>", "系统提示", {
              dangerouslyUseHTMLString: true,
              type: "success"
            })
        }else{
          addWord(this.form).then(response => {
            this.$alert("<font color='red'> 添加成功</font>", "系统提示", {
              dangerouslyUseHTMLString: true,
              type: "success"
            })
              .then(() => {
                this.getList();
                this.num = 3;
              })
              .catch(() => {});
          });
        }
            
          
       
      }
    },
    init() {
      this.$root.num = this.$route.query.id;
      if (this.$route.query.pid != null) {
        this.$root.num = this.$route.query.pid;
      }

      console.log(localStorage.getItem("userId") + "1111");
      this.queryParams.userId =
        localStorage.getItem("userId") == null
          ? "0"
          : localStorage.getItem("userId");

      if (localStorage.getItem("token")) {
        this.username = localStorage.getItem("userName");
        this.num = 3;
        getWordInfo(this.queryParams).then(response => {
          this.dataList = response.rows;
          this.totalCount = response.total;
          this.totalPage = Math.ceil(this.totalCount / 10);
        });
      } else {
        this.num = 0;
      }
      getColumnList(this.$route.query.id).then(response => {
        this.columnList = response.data;
        this.columnPidName = this.columnList.label;
        this.childrenLsit = this.columnList.children;
        this.childrenLsit.forEach(item => {
          if (item.id == this.$route.query.id) {
            this.templateTypeId = item.templateType;
            console.log(this.templateTypeId);
            this.columnName = item.label;
          }
        });
      });
    },
    inits(id) {
      console.log(this.$route.query.id);
      this.$root.num = this.$route.query.id;
      if (this.$route.query.pid != null) {
        this.$root.num = this.$route.query.pid;
      }

      this.queryParams.userId =
        localStorage.getItem("userId") == null
          ? "0"
          : localStorage.getItem("userId");
      if (localStorage.getItem("token")) {
        this.num = 3;
        getDataInfo(this.queryParams).then(response => {
          this.dataList = response.rows;
          this.totalCount = response.total;
          this.totalPage = Math.ceil(this.totalCount / 10);
        });
      } else {
        this.num = 0;
      }

      getColumnList(this.$route.query.id)
        .then(response => {
          this.columnList = response.data;
          this.columnPidName = this.columnList.label;
          this.childrenLsit = this.columnList.children;
          this.childrenLsit.forEach(item => {
            if (item.id == this.$route.query.id) {
              this.templateTypeId = item.templateType;
              console.log(this.templateTypeId);
              this.columnName = item.label;
            }
          });
        })
        .catch(() => {
          this.templateTypeId = 6;
        });
    },
    showStatus(str) {
      if (str == 1) return "已回复";
      if (str == 2) return "未回复";
      if (str == 3) return "追问未回复";
    },
    toDetails(id) {
      this.$router.push({ path: "/Aitrcle/Details", query: { id: id } });
    },
    showDataInfo(index) {
      console.log("11111");
      this.queryParams.pageNum = index;
      getDataInfo(this.queryParams).then(response => {
        this.dataList = response.rows;
        this.totalCount = response.total;
        this.totalPage = Math.ceil(this.totalCount / 10);
      });
    },
    fromMart(str) {
      const strAry = str.split("");
      strAry[str.indexOf("-")] = "   ";
      return strAry.join("");
    },
    getColumnDataInfo(id, templateType, label) {
      this.$root.num = id;
      console.log(localStorage.getItem("userId") + "1111");
      this.queryParams.userId =
        localStorage.getItem("userId") == null
          ? "0"
          : localStorage.getItem("userId");

      if (localStorage.getItem("token")) {
        this.username = localStorage.getItem("userName");
        this.num = 3;
        this.queryParams.pageNum = 1;
        getWordInfo(this.queryParams).then(response => {
          this.dataList = response.rows;
          this.totalCount = response.total;
          this.totalPage = Math.ceil(this.totalCount / 10);
        });
      } else {
        this.num = 0;
      }
    },
    toAdd() {
      this.num = 1;
      this.form.content = "";
      this.form.leaveTitle = "";
      this.form.phone = "";
      this.form.userName = "";
    },
    toDetail(id) {
      this.num = 2;
      this.contentWord = "";
      getWordData(id).then(req => {
        this.wordList = req.data;
      });
    }
  }
};
</script>

<style scoped>
@import "../styles/home.css";
@import "../styles/pages.css";
@import "../styles/style.css";
.newsytle {
  color: red;
}

.row {
  margin-left: 0;
  margin-right: 0;
  margin-top: 15px;
}

.table01 {
  border: none;
  height: 100px;
  width: 868px;
  text-align: center;
}
.table01 tbody tr {
  border: none;
}
.table01 thead th {
  border: none;
}
thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
}
.table01 td + td {
  border: none;
}
.table01 tbody tr + tr {
  border-bottom: 1px dashed #dcdcdc;
  border-top: 1px dashed #dcdcdc;
}
.table01 td + td,
.table01 th + th {
  border-left: none;
}
.table01 td a {
  color: #444444;
  text-decoration: none;
}
.table01 td a:hover {
  color: #f00000;
}
.btn.common,
.btn.bgRed {
  background: white;
}
.btn.common:hover,
.btn.bgRed:hover {
  background: white;
}
.btn.common {
  color: #0d4c99;
}
.btn.bgRed {
  color: #f00000;
}
.header-r .search .searchMenu {
  margin-top: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/leaveWord.vue